module.exports = __webpack_public_path__ + "static/media/cafe24-case3.9f34d2f6.png";